// Components==============
import { faKeyboard } from '@fortawesome/pro-regular-svg-icons';
import { faBackspace } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Consonants from 'components/UI/SoundTypes/Consonants';
import LongSounds from 'components/UI/SoundTypes/LongSounds';
import ShortSounds from 'components/UI/SoundTypes/ShortSounds';
import UncommonSounds from 'components/UI/SoundTypes/SpecialCharacterSound';
import SpecialSounds from 'components/UI/SoundTypes/SpecialSounds';
import StupidSounds from 'components/UI/SoundTypes/StupidSound';
import TwoSymbolSounds from 'components/UI/SoundTypes/TwoSymbolSounds';
import React, { createContext, useContext, useRef } from 'react';
import { useParams } from 'react-router';
import { GlobalContext } from 'utilities/GlobalContext';
import Circle from '../Circle/Circle';
import './Keyboard.module.scss';
import { useSelector } from 'react-redux';
// =========================

const Buttons = () => {
    const { setKeyboardInput } = useContext(GlobalContext);

    return (
        <div styleName="buttons">
            <Circle
                onClick={() =>
                    setKeyboardInput((prev) => [...prev, 'backspace'])
                }
            >
                <FontAwesomeIcon icon={faBackspace} styleName="backspace" />
            </Circle>
            <Circle
                onClick={() => setKeyboardInput((prev) => [...prev, 'space'])}
            >
                <svg width="26.045" height="9.586" viewBox="0 0 26.045 9.586">
                    <path
                        d="M583.4,240.551v6.586h23.045v-6.586"
                        transform="translate(-581.899 -239.051)"
                        fill="none"
                        stroke="#1368e5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="4"
                    />
                </svg>
            </Circle>
            <Circle
                onClick={() => setKeyboardInput((prev) => [...prev, 'enter'])}
            >
                <svg width="22.697" height="15.72" viewBox="0 0 22.697 15.72">
                    <g transform="translate(-663.05 -236.559)">
                        <path
                            d="M583.4,248.629h16.848v-8.078h-6.691"
                            transform="translate(84 -2.492)"
                            fill="none"
                            stroke="#1368e5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="3"
                        />
                        <path
                            d="M670.629,242l-4.079,4.079,4.079,4.079"
                            transform="translate(-2)"
                            fill="none"
                            stroke="#1368e5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="3"
                        />
                    </g>
                </svg>
            </Circle>
        </div>
    );
};

export const KeyboardContext = createContext({ isKeyboard: false });

export default function Keyboard() {
    const { keyboardIsOpen, setKeyboardIsOpen } = useContext(GlobalContext);
    const ref = useRef(null);
    // useOnClickOutside(ref, () => setKeyboardIsOpen(false));

    const { treatmentId } = useParams() as { treatmentId: string };
    const treatment = useSelector(
        (store: ReduxStore) => store.treatment?.entities?.byId[treatmentId]
    );
    let keyboardIsExtended = false;
    if (treatment && parseInt(treatment.number) >= 53) {
        keyboardIsExtended = true;
    }

    return (
        <KeyboardContext.Provider value={{ isKeyboard: true }}>
            <div ref={ref} styleName="wrapper">
                <Circle
                    background="#1368E5"
                    onClick={() => setKeyboardIsOpen((prev) => !prev)}
                >
                    <FontAwesomeIcon icon={faKeyboard} />
                </Circle>
                {keyboardIsOpen && (
                    <div
                        styleName={`keyboard ${
                            keyboardIsExtended
                                ? 'keyboard-is-extended'
                                : 'keyboard-is-not-extended'
                        }`}
                    >
                        <div
                            styleName="inner-grid"
                            style={{
                                gridRow: keyboardIsExtended ? '1/3' : '1',
                                gridColumn: keyboardIsExtended ? 1 : 'initial',
                            }}
                        >
                            <ShortSounds />
                            <LongSounds keyboard />
                            <TwoSymbolSounds />
                        </div>
                        <div styleName="inner-grid">
                            <SpecialSounds />
                            <StupidSounds keyboard />
                            {!keyboardIsExtended && <Buttons />}
                        </div>
                        {keyboardIsExtended && <Buttons />}
                        <div styleName="inner-grid">
                            <Consonants />
                        </div>
                        {keyboardIsExtended && (
                            <div styleName="inner-grid">
                                <UncommonSounds />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </KeyboardContext.Provider>
    );
}
